import { useMemo } from 'react';
import type { CountryISO } from '@/constants/countries';
import { ORDERED_MARKETS, PRIMARY_MARKETS } from '@/constants/markets';
import { getPath } from '@/router/utils';
import { ROUTE_STOCKS_MARKET } from '@/constants/routes';

interface MarketOptions {
  option: CountryISO | string;
  href?: string;
  label: string;
}

export default function useMarketOptions(
  includeGlobal = false,
  route = ROUTE_STOCKS_MARKET,
  payload?: any
): MarketOptions[] {
  const marketOptions = useMemo(
    () => [
      ...(includeGlobal
        ? [
            {
              option: 'global',
              label: 'Global',
              href: getPath({
                type: route,
                payload: { market: 'global', ...payload },
              }),
            },
          ]
        : []),
      ...ORDERED_MARKETS.filter((m) => m !== 'lb').map((market) => {
        return {
          option: market,
          label: PRIMARY_MARKETS[market].label,
          href: getPath({
            type: route,
            payload: { market, ...payload },
          }),
        };
      }),
    ],
    [route, payload]
  );

  return marketOptions;
}
